import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoImovelEnum } from 'graphql/types.generated'

import { tipoImovelEnumRecord } from './condicoes-moradia-model'

type TipoImovelSelectFieldProps = CustomSelectFieldProps<TipoImovelEnum>

export function TipoImovelSelectField(props: TipoImovelSelectFieldProps) {
  return <SelectField<TipoImovelEnum> items={items} itemToString={itemToString} {...props} />
}

const items = Object.keys(tipoImovelEnumRecord) as TipoImovelEnum[]

const itemToString = (item: TipoImovelEnum) => item && tipoImovelEnumRecord[item]
